export const examples = [
  {
    id: 'john',
    label: 'John',
    kind: 'Agency',
    situation:
      'He needed reliable support for client sites without hiring an in-house technical team.',
    whatWeDo:
      'We maintain and support his clients’ websites under his brand. He keeps the relationships and the recurring revenue.',
    homeLine: 'John — we handle the technical work behind his agency brand.'
  },
  {
    id: 'ellen',
    label: 'Ellen',
    kind: 'Business',
    situation:
      'The website, email, and hosting sat with different vendors. When something broke, nobody owned the whole setup.',
    whatWeDo:
      'We took the website, email, and hosting under one person. Updates, DNS, and deliverability are one conversation.',
    homeLine: 'Ellen — website, email, and hosting under one person.'
  },
  {
    id: 'brett',
    label: 'Brett',
    kind: 'Migration',
    situation:
      'The website and email had to change hosts, with SSL in place, without taking the site down during the day.',
    whatWeDo:
      'We migrated the website and email, set up SSL at the new host, and did the cutover after hours.',
    homeLine:
      'Brett — site, email, and SSL moved after hours so users were not disrupted.'
  },
  {
    id: 'chris',
    label: 'Chris',
    kind: 'WordPress',
    situation:
      'The WordPress site was stuck. Other people had already tried.',
    whatWeDo:
      'We stayed with the questions and got the site working when others had not been able to.',
    homeLine: 'Chris — WordPress help after others could not get it working.'
  }
];

export const quotes = [
  {
    id: 'migration',
    text: 'He helped us migrate our web and email hosting, and set up an SSL at our new host. He was easy to work with, knowledgeable, quick, and extremely professional. He also accommodated us by working during late hours so as not to disrupt the users of our website.',
    attribution: 'Brett',
    home: true
  },
  {
    id: 'wordpress',
    text: 'He has been very patient with all of my questions and has helped get my website to a great place when others were unable to do so.',
    attribution: 'Chris',
    home: false
  }
];

export const sampleCareNote = {
  eyebrow: 'Sample monthly care note',
  title: 'Your website — your name here',
  office: 'ManagedSite\nOperations',
  items: [
    {
      name: 'Updates',
      detail:
        'WordPress, plugins, and theme reviewed. Two plugin updates applied. One held for a conflict check.',
      status: 'Done'
    },
    {
      name: 'Backups',
      detail: 'Offsite backups completed. Restore point verified.',
      status: 'Done'
    },
    {
      name: 'SSL and DNS',
      detail: 'Certificate valid. No unexpected DNS changes.',
      status: 'Clear'
    },
    {
      name: 'Email',
      detail: 'Form mail delivered. Authentication records unchanged.',
      status: 'Clear'
    },
    {
      name: 'Needs a decision',
      detail:
        'A plugin the site still uses is nearing end of life. We will send options before next month.',
      status: 'Open'
    }
  ],
  footer: 'This is the kind of note we send each month.'
};

export const homeQuote = quotes.find((quote) => quote.home);

export const extraQuotes = quotes.filter((quote) => !quote.home);

export const sampleReviewNote = {
  eyebrow: 'Sample Digital Review',
  title: 'Your website — your name here',
  office: 'From Dave',
  items: [
    {
      name: 'What is going on',
      detail:
        'The site loads and SSL is valid. The contact form may not be delivering — the sending domain has no SPF.'
    },
    {
      name: 'What can wait',
      detail:
        'A few plugins look dated. Not urgent if you are not seeing errors on the site.'
    },
    {
      name: 'Next step',
      detail:
        'A one-time cleanup first. Monthly care after that if you want someone watching the rest.'
    }
  ],
  footer: 'This is the kind of note Dave sends back. No logins needed to start.'
};

export const sampleAgencyNote = {
  eyebrow: 'Sample note you can forward',
  title: 'Client site — your brand here',
  office: 'Prepared\nfor your agency',
  items: [
    {
      name: 'Updates',
      detail:
        'WordPress, plugins, and theme reviewed. Two plugin updates applied. One held for a conflict check.',
      status: 'Done'
    },
    {
      name: 'Backups',
      detail: 'Offsite backups completed. Restore point verified.',
      status: 'Done'
    },
    {
      name: 'SSL and DNS',
      detail: 'Certificate valid. No unexpected DNS changes.',
      status: 'Clear'
    },
    {
      name: 'Needs a decision',
      detail:
        'A plugin the site still uses is nearing end of life. Options are ready for you to take to the client.',
      status: 'Open'
    }
  ],
  footer: 'Written so you can send it as your own. We stay off the note.'
};
